import React, { useState } from "react";
import axios from "axios";

export default function NewAccount() {
  const [name, setAccount] = useState("");
  const [company, setCompany] = useState("");
  const [platform, setPlatform] = useState("");
  const [imageURL, setUrl] = useState("");

  const [submitting, setSubmitting] = useState(false);
  const [complete, setComplete] = useState(false);
  const [errorField, setErrorField] = useState("");
  const [errorMsg, setErrorMsg] = useState("");

  // basit doğrulama
  function validate() {
    if (!name.trim()) return "Account Name is required.";
    if (!platform.trim()) return "Platform is required.";
    if (!company.trim()) return "Company Name is required.";
    return "";
  }

  async function addaccount(e) {
    e.preventDefault();
    setComplete(false);
    setSubmitting(true);
    setErrorField("");
    setErrorMsg("");

    const v = validate();
    if (v) {
      setSubmitting(false);
      setErrorField(v);
      return;
    }

    try {
      await axios.post("https://act-api.vercel.app/addanaccount", {
        name,
        company,
        imageURL,
        platform,
      });

      setComplete(true);
      setAccount("");
      setCompany("");
      setPlatform("");
      setUrl("");
    } catch (error) {
      const msg = error?.response?.data?.hata || "Operation failed. Please try again.";
      setErrorField(msg);
    } finally {
      setSubmitting(false);
    }
  }

  // küçük avatar önizleme
  const [brokenImg, setBrokenImg] = useState(false);
  const showInitials = !imageURL || brokenImg;
  const initials = (name?.trim()?.[0] || "A").toUpperCase();

  return (
    <div className="min-h-screen bg-gradient-to-b from-slate-50 to-slate-100 text-slate-800">
      {/* Üst başlık */}
      <div className="sticky top-0 z-10 bg-white/70 backdrop-blur supports-[backdrop-filter]:bg-white/50 border-b border-slate-200">
        <div className="mx-auto max-w-md px-4 sm:px-6 py-3 flex items-center justify-between">
          <h1 className="text-lg font-semibold">New Account</h1>
          <span className="text-sm text-slate-500">Create a new advertising account</span>
        </div>
      </div>

      {/* İçerik */}
      <div className="mx-auto max-w-md px-4 sm:px-6 py-8">
        {errorMsg && (
          <div className="mb-6 rounded-xl border border-red-200 bg-red-50 p-4 text-sm text-red-700">
            {errorMsg}
          </div>
        )}
        {complete && (
          <div className="mb-6 rounded-xl border border-green-200 bg-green-50 p-4 text-sm text-green-700">
            You added an account.
          </div>
        )}
        {errorField && (
          <div className="mb-6 rounded-xl border border-amber-200 bg-amber-50 p-4 text-sm text-amber-800">
            {errorField}
          </div>
        )}

        <form
          onSubmit={addaccount}
          className="rounded-2xl border border-slate-200 bg-white p-6 shadow-sm"
        >
          {/* Üst kısım: avatar + kısa info */}
          <div className="flex items-center gap-4">
            <div className="w-16 h-16 rounded-full ring-2 ring-slate-100 bg-slate-100 overflow-hidden flex items-center justify-center">
              {showInitials ? (
                <span className="text-slate-500 font-semibold">{initials}</span>
              ) : (
                <img
                  src={imageURL}
                  alt={name || "Account"}
                  className="w-full h-full object-cover"
                  onError={() => setBrokenImg(true)}
                />
              )}
            </div>
            <div className="min-w-0">
              <div className="text-sm text-slate-500">Preview</div>
              <div className="font-semibold truncate">{name || "Account Name"}</div>
              <div className="text-xs text-slate-500 truncate">
                {company || "Company"} • {platform || "Platform"}
              </div>
            </div>
          </div>

          {/* Form alanları */}
          <div className="mt-6 grid grid-cols-1 gap-4">
            <div>
              <label className="block text-sm font-medium text-slate-700 mb-1">
                Account Name <span className="text-red-500">*</span>
              </label>
              <input
                placeholder="Enter Account Name"
                className="w-full rounded-lg border border-slate-300 bg-white px-3 py-2 text-sm outline-none focus:ring-4 focus:ring-blue-100 focus:border-blue-400"
                onChange={(e) => setAccount(e.target.value)}
                value={name}
                autoComplete="off"
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-slate-700 mb-1">
                Platform <span className="text-red-500">*</span>
              </label>
              <select
                value={platform}
                onChange={(e) => setPlatform(e.target.value)}
                className="w-full rounded-lg border border-slate-300 bg-white px-3 py-2 text-sm outline-none focus:ring-4 focus:ring-blue-100 focus:border-blue-400"
              >
                <option value="">Select a platform</option>
                <option value="Meta">Meta</option>
                <option value="Google">Google</option>
                <option value="LinkedIn">LinkedIn</option>
              </select>
            </div>

            <div>
              <label className="block text-sm font-medium text-slate-700 mb-1">
                Company Name <span className="text-red-500">*</span>
              </label>
              <input
                placeholder="Enter Company Name"
                className="w-full rounded-lg border border-slate-300 bg-white px-3 py-2 text-sm outline-none focus:ring-4 focus:ring-blue-100 focus:border-blue-400"
                onChange={(e) => setCompany(e.target.value)}
                value={company}
                autoComplete="organization"
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-slate-700 mb-1">
                Image URL
              </label>
              <input
                placeholder="https://…"
                className="w-full rounded-lg border border-slate-300 bg-white px-3 py-2 text-sm outline-none focus:ring-4 focus:ring-blue-100 focus:border-blue-400"
                onChange={(e) => {
                  setBrokenImg(false);
                  setUrl(e.target.value);
                }}
                value={imageURL}
                autoComplete="off"
              />
              <p className="mt-1 text-xs text-slate-500">
                Geçerli bir görsel URL’i girersen önizleme güncellenir.
              </p>
            </div>
          </div>

          <div className="mt-6">
            <button
              type="submit"
              disabled={submitting}
              className="w-full inline-flex items-center justify-center gap-2 rounded-lg bg-blue-600 px-4 py-2 text-sm font-semibold text-white shadow-sm hover:bg-blue-700 focus:outline-none focus:ring-4 focus:ring-blue-200 disabled:opacity-60 disabled:cursor-not-allowed"
            >
              {submitting ? (
                <>
                  <svg
                    className="h-4 w-4 animate-spin"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle
                      className="opacity-25"
                      cx="12"
                      cy="12"
                      r="10"
                      stroke="currentColor"
                      strokeWidth="4"
                    ></circle>
                    <path
                      className="opacity-75"
                      fill="currentColor"
                      d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
                    ></path>
                  </svg>
                  Saving…
                </>
              ) : (
                "Save"
              )}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
